import { render } from "./SideActions.vue?vue&type=template&id=21e8d135&scoped=true"
import script from "./SideActions.vue?vue&type=script&lang=js"
export * from "./SideActions.vue?vue&type=script&lang=js"

import "./SideActions.vue?vue&type=style&index=0&id=21e8d135&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e8d135"]])

export default __exports__